import React from 'react';
import { View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';
import { radius, space, useColors } from '../theme';

export function Panel({
  children,
  style,
}: {
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}) {
  const colors = useColors();
  return (
    <View
      style={[
        {
          backgroundColor: colors.surface,
          borderWidth: 1,
          borderColor: colors.line,
          borderRadius: radius.lg,
          paddingVertical: 16,
          paddingHorizontal: space.xl,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
}
